/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type AvatarPerson_orgPerson = {
    readonly id: string;
    readonly primaryCalendarId: string;
    readonly isYou: boolean;
    readonly userId: string | null;
    readonly profile: {
        readonly givenName: string | null;
        readonly familyName: string | null;
        readonly externalImageUrl: string | null;
    } | null;
    readonly __typename: "OrgPerson";
    readonly " $refType": "AvatarPerson_orgPerson";
};
export type AvatarPerson_orgPerson$data = AvatarPerson_orgPerson;
export type AvatarPerson_orgPerson$key = {
    readonly " $data"?: AvatarPerson_orgPerson$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AvatarPerson_orgPerson">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AvatarPerson_orgPerson",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "primaryCalendarId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isYou",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "profile",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "givenName",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "familyName",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "externalImageUrl",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "OrgPerson",
    "abstractKey": null
} as any;
(node as any).hash = 'd3e7e8bb629c74ab94067ad1bc99e887';
export default node;
